module.exports = __webpack_public_path__ + "static/media/S1N2-2.7ce8c36a.svg";